import React, { ReactElement, useState, useEffect } from 'react'

import { TrainingGroup } from '../../../types/training'
import { getTrainingGroups } from '../../../api/training-group'
import TrainingGroups from '../../../components/Admin/training-group/preview-training-group'

const Dashboard = (): ReactElement => {
  const [trainingsGroups, setTrainingsGroups] = useState<TrainingGroup[]>()
  useEffect(() => {
    getTrainingGroups().then((data) => {
      setTrainingsGroups(data)
    })
  }, [])

  return <TrainingGroups trainingsGroups={trainingsGroups} />
}

export default Dashboard
